import { render, staticRenderFns } from "./CaseDetailHeader.vue?vue&type=template&id=7ef42e5a"
import script from "./CaseDetailHeader.vue?vue&type=script&lang=js"
export * from "./CaseDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports